// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JobOrderTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JobOrderType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get commonName() {
    if (this.id == JobOrderTypeEnum.EmployeeOrder) {
      return 'User Order';
    }

    if (this.id == JobOrderTypeEnum.AdminOrder) {
      return 'Admin Order';
    }

    return '';
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: JobOrderTypeEnum;
  /** String(250) */
  description!: string;
  /** String(60) */
  name!: string;
}

